/* ==========================================================
   Zenbodi AM/PM v3, store config
   Everything you may need to change before launch lives here.
   ========================================================== */
window.ZENBODI = {
  /* Jose, 9 Oct 2026: this build is FINAL, treat it exactly as the Vercel reference.
     true keeps the 2 hour countdown (restarts on every load), the 93% sold bar, the customer photo strip
     and the "Verified customer" tags on the reviews. Do not switch it off without asking Jose. */
  draftMocks: true,
  draftTimerHours: 2,
  draftStockPct: 93,

  /* Customer photo strip above the stories (assets ampm-ugc-*). */
  ugc: ["u01", "u13", "u07", "u14", "u02", "u16", "u04", "u11", "u15", "u05", "u17", "u06", "u08", "u18", "u03", "u09", "u10"],

  storeDomain: "",

  /* Offer, 2 options only (Oct 8 pricing table). AM + PM always ship together.
     monthPrice is the 1 month AM + PM price, used to work out the compare at price and savings.
     3 months: compare at = 3 x $58 + $29 coffee = $203, so the saving shown is $74 (36%). */
  monthPrice: 58,
  offers: [
    { id: "1m", price: 58, months: 1, bottles: 2 },
    { id: "3m", price: 129, months: 3, bottles: 6, gift: "Mind + Focus Coffee", giftValue: 29, flag: "Best value" }
  ],
  defaultOffer: 1,         /* 0 or 1. Opens on the 3 month offer */
  shippingValue: 4.95,     /* shown crossed out in the perks row, shipping is free on both offers */
  deliveryDays: 5,         /* business days used for the "delivered by" estimate (PLACEHOLDER) */

  /* Social proof line. soldLabel is from Jose (1M+ sold over the product's history).
     rating MUST match the real review average (Amazon or the review app). PLACEHOLDER until confirmed. */
  rating: 4.9,
  soldLabel: "Over 1 million sold",
  reviewCount: null,       /* e.g. "2,431" once the real review count is known. Shows "Rated 4.9 from 2,431 reviews" */

  /* Announcement bar countdown. Set a REAL end date for the offer, for example "2026-10-12T23:59:00-04:00".
     null hides the timer. The timer never resets on reload. */
  saleEndsAt: null,

  /* Stock bar under the buy box chips. Only shows when pct is a real number from inventory, for example 87.
     label example "Early Black Friday stock". */
  stock: { pct: null, label: "Early Black Friday deal" },

  /* "Real results you can feel" figures, final per Jose. resultsAreSample stays false so no note shows. */
  results: [
    { n: "87%", t: "feel calmer and more focused during the day" },
    { n: "84%", t: "say they fall asleep more easily" },
    { n: "81%", t: "wake up feeling more refreshed" },
    { n: "90%", t: "would recommend AM/PM to a friend" }
  ],
  resultsAreSample: false,

  /* Shopify variant ids, one per offer, plus the free coffee variant added to 3 month orders.
     The gift keeps its real price, the automatic discount makes it $0. Never price it at $0 itself. */
  variants: { "1m": 53121390444855, "3m": 53121390477623 },  /* Zenbodi AM/PM System, 1 Month / 3 Months + Free Coffee */
  giftVariant: 53121396965687,  /* Mind + Focus Coffee (Free Gift), $29, zeroed by "AM/PM 3 months: free Mind + Focus Coffee" */

  /* Reviews. Oct 2026 (Michael / Zenbodi): only real customer reviews from Judge.me may show, so the
     sample reviews are off. While ampm-reviews.json is empty the stories and reviews sections stay hidden.
     Put real Judge.me reviews in ampm-reviews.json (verified: true) to bring them back. */
  useSampleReviews: false
};
